import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import EditButton from "../../common/buttons/EditButton";
import {
  conferenceFilter,
  conferenceManualApproveAction,
  manualConference,
} from "../../redux/actions/conference/conference_action";
import BackButton from "../../common/buttons/BackButton";
import DataTable from "../../common/shared/DataTable";
import PageTitle from "../../common/shared/PageTitle";
import formatNumber from "../../utils/formatNumber";
import ConferenceIcon from "../../common/icons/ConferenceIcon";
import DownloadButton from "../../common/buttons/DownloadButton";
import saveDownload from "../../utils/downloadFile";
import AlertMessage from "../../common/actions/AlertMessage";
import Loader from "../../common/loaders/Loader";
import Modal from "../../common/actions/Modal";
import InputArea from "../../common/forms/InputArea";
import FilterButton from "../../common/buttons/FilterButton";
import ClearFilterButton from "../../common/buttons/ClearFilterButton";
import FilterInput from "../../common/shared/FilterInput";
import {
  Card,
  CardBody,
  Select,
  Option,
  Input,
} from "@material-tailwind/react";
import { DataGrid } from "@mui/x-data-grid";
import InputText from "../../common/forms/InputText";

const filterItem = [
  { name: "Bar Number", value: "bar_number" },
  { name: "Name", value: "name" },
];

function ConferenceManualList() {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [editLoading, setEditLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchData, setSearchData] = useState({ search: "" });
  const [totalData, setTotalData] = useState([]);
  const [filteredResult, setFilteredResult] = useState([]);

  const [altSearch, setAltSearch] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const [filterText, setFilterText] = useState("");
  const [selectedColumn, setSelectedColumn] = useState(
    filterItem[0]?.value || ""
  );

  const dispatch = useDispatch();

  const userData = useSelector((state) => state.auth?.userData);
  const { approve, conferenceError, search } = useSelector(
    (state) => state.conference
  );

  const handleFilterTextChange = (e) => {
    setFilterText(e.target.value);
  };

  const editForm = (params) => {
    setEditModal(!editModal);
    setFormData({ ...formData, ...params.row });
  };

  const updateFormValue = ({ updateType, value }) => {
    setFormData({ ...formData, [updateType]: value });
  };

  const handleManual = (e) => {
    e.preventDefault();

    const sendData = {
      productId: id,
      notes: formData.notes,
      id: formData.id,
    };

    setEditLoading(true);
    dispatch(manualConference(sendData)).finally(() => {
      setEditLoading(false);
      setEditModal(false);
      window.location.reload();
    });
  };

  const handleSearch = (e) => {
    e.preventDefault();

    setSearchLoading(true);
    setFilterModal(false);
    setShowFilter(true);

    const sendData = {
      category: "registered",
      search: filterText,
      type: selectedColumn,
      section: "manual",
    };

    dispatch(conferenceFilter(sendData)).finally(() => setSearchLoading(false));
  };

  const handleClearSearch = () => {
    if (altSearch.length > 0) {
      setAltSearch([]);
    } else {
      setShowFilter(false);
      setFilteredResult([]);
    }
  };

  const updateSearchValue = ({ updateType, value }) => {
    setSearchData({ ...searchData, search: value });
  };

  const handleFilter = (filteredList) => {
    setFilteredResult(filteredList);
    setFilterModal(false);
    setShowFilter(true);
  };

  const handleColumnChange = (event) => {
    setSelectedColumn(event);
  };

  const columns = [
    {
      field: "arrayIndex",
      headerName: "ID",
      width: 80,
      valueFormatter: (params) => (params.value + 1).toString(),
    },
    {
      field: "full_name",
      headerName: "Name",
      flex: 1,
      valueGetter: (params) =>
        params?.row?.full_name + " - " + params?.row?.bar_number,
    },
    {
      field: "chamber",
      headerName: "Chamber",
      flex: 1,
      renderCell: (params) => {
        return (
          <div className="flex flex-col">
            {params?.row?.chamber?.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </div>
        );
      },
    },
    { field: "amount", headerName: "Amount", width: 100 },
    {
      field: "email",
      headerName: "Email Address",
      width: 200,
      renderCell: (params) => {
        <div className="text-wrap my-2">
          <span>{params?.row?.email}</span>;
        </div>;
      },
    },
    {
      field: "phone",
      headerName: "Phone #",
      width: 100,
      renderCell: (params) => {
        <div className="text-wrap my-2">
          <span>{params?.row?.phone}</span>;
        </div>;
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      sortable: "false",
      renderCell: (params) =>
        userData.role_id === 3 && (
          <strong>
            <EditButton onClick={() => editForm(params)} />
          </strong>
        ),
    },
  ];

  // const columns = [
  //   {
  //     field: "name",
  //     headerName: "Name",
  //     flex: 1,
  //     valueGetter: (params) => params?.row?.name,
  //   },
  //   {
  //     field: "bar_number",
  //     headerName: "Bar Number",
  //     width: 100,
  //     valueGetter: (params) => params?.row?.bar_number,
  //   },
  //   {
  //     field: "chamber",
  //     headerName: "Chamber",
  //     flex: 1,
  //     renderCell: (params) => {
  //       return (
  //         <div className="flex flex-col">
  //           {params?.row?.chamber.map((item) => (
  //             <span key={item}>{item}</span>
  //           ))}
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     field: "amount",
  //     headerName: "Amount(GHS)",
  //     width: 100,
  //     valueGetter: (params) => params?.row?.amount,
  //   },
  //   {
  //     field: "email",
  //     headerName: "Email Address",
  //     width: 200,
  //     renderCell: (params) => {
  //       <div className="text-wrap my-2">
  //         <span>{params?.row?.email}</span>;
  //       </div>;
  //     },
  //   },
  //   {
  //     field: "phone",
  //     headerName: "Phone #",
  //     width: 100,
  //     renderCell: (params) => {
  //       <div className="text-wrap my-2">
  //         <span>{params?.row?.phone}</span>;
  //       </div>;
  //     },
  //   },

  //   {
  //     field: "actions",
  //     headerName: "Actions",
  //     width: 100,
  //     sortable: "false",
  //     renderCell: (params) =>
  //       userData.role_id === 3 && (
  //         <strong>
  //           <EditButton onClick={() => editForm(params)} />
  //         </strong>
  //       ),
  //   },
  // ];

  useEffect(() => {
    dispatch(conferenceManualApproveAction(id)).finally(() =>
      setLoading(false)
    );
  }, [dispatch, id]);

  useEffect(() => {
    if (approve) {
      setTotalData(approve);
    }

    if (search) {
      setFilteredResult(search);
    }
  }, [approve, search]);

  useEffect(() => {
    const filterData = filteredResult.filter((item) => {
      const searchTermLowerCase = searchTerm.toLowerCase();
      return (
        item?.full_name?.toLowerCase().includes(searchTermLowerCase) ||
        item?.bar_number?.toLowerCase().includes(searchTermLowerCase) ||
        item?.gender?.toLowerCase().includes(searchTermLowerCase) ||
        item?.chamber.some((chamber) =>
          chamber.toLowerCase().includes(searchTermLowerCase)
        )
      );
    });

    setAltSearch(filterData);
  }, [filteredResult, searchTerm]);

  return (
    <>
      {conferenceError && (
        <AlertMessage status="error" message={conferenceError} />
      )}

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="flex justify-between p-4">
            <div className="flex items-center">
              <PageTitle
                title="Conference Manual Request"
                subheading={formatNumber(approve.length)}
                icon={<ConferenceIcon />}
              />
            </div>

            <div className="flex items-center gap-4">
              <DownloadButton
                onClick={() => saveDownload(approve, "Conference Manual list")}
              />
              <FilterButton onClick={() => setFilterModal(true)} />
              {showFilter && <ClearFilterButton onClick={handleClearSearch} />}
            </div>
          </div>

          <BackButton />

          {/* {filteredResult.length > 0 && (
            <FilterInput value={searchTerm} onChange={handleFilterTextChange} />
          )} */}

          {filterModal && (
            <Modal
              title="Filter Data"
              size="sm"
              open={true}
              content={
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                  <div className="relative w-full max-w-xs">
                    <Select
                      onChange={handleColumnChange}
                      value={selectedColumn}
                      label="Select Column"
                    >
                      {filterItem.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  </div>

                  <div className="relative w-full max-w-xs">
                    <Input
                      label="Type here"
                      className="input input-bordered w-full"
                      value={filterText}
                      onChange={handleFilterTextChange}
                    />
                  </div>
                </div>
              }
              actionLabel="Filter"
              closeLabel="Close"
              onAction={(e) => handleSearch(e)}
              onClose={() => setFilterModal(false)}
            />
          )}

          {/* {filterModal && (
            <Modal
              title="Search Filter"
              open={filterModal}
              handler={handleFilter}
              content={
                <InputText
                  type="text"
                  defaultValue=""
                  updateType="search"
                  labelTitle="Search"
                  updateFormValue={updateSearchValue}
                />
              }
              closeLabel="Close"
              actionLabel="Search"
              onClose={() => setFilterModal(!filterModal)}
              onAction={(e) => handleSearch(e)}
              loading={searchLoading}
            />
          )} */}

          <Card className="w-full p-6 shadow-xl mb-20">
            <CardBody>
              <DataGrid
                sx={{ border: 0 }}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      gender: false,
                      year: false,
                    },
                  },
                }}
                rows={
                  showFilter
                    ? altSearch.length > 0
                      ? altSearch?.map((row, index) => {
                          return {
                            ...row,
                            arrayIndex: index,
                          };
                        })
                      : filteredResult?.map((row, index) => {
                          return {
                            ...row,
                            arrayIndex: index,
                          };
                        })
                    : totalData.map((row, index) => {
                        return {
                          ...row,
                          arrayIndex: index,
                        };
                      })
                }
                columns={columns}
              />
            </CardBody>
          </Card>

          {/* <DataTable rows={approve} columns={columns} /> */}

          {editModal && (
            <Modal
              title="Complete Manual Processing"
              open={editModal}
              handler={editForm}
              content={
                <form>
                  <InputArea
                    defaultValue={formData.notes}
                    updateType="notes"
                    labelTitle="notes"
                    updateFormValue={updateFormValue}
                  />
                </form>
              }
              closeLabel="Close"
              actionLabel="Proceed"
              onClose={() => setEditModal(false)}
              onAction={(e) => handleManual(e)}
              loading={editLoading}
            />
          )}
        </>
      )}
    </>
  );
}

export default ConferenceManualList;
